module.exports = __webpack_public_path__ + "img/logo.1fee3061.svg";